import { render, staticRenderFns } from "./AdminTile.vue?vue&type=template&id=4d220e7f&scoped=true"
import script from "./AdminTile.vue?vue&type=script&lang=js"
export * from "./AdminTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d220e7f",
  null
  
)

export default component.exports